<template>
	<div class="v-container">
		<div class="v-page-header">作品管理</div>
		<div class="v-header">
			<div>
				<el-button size="small" type="primary" @click="add">新增作品</el-button>
			</div>
			<div>
				<el-input v-model="keyword" class="v-form-item" size="mini" placeholder="作品名称" style="width: 170px"></el-input>
				<el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)">搜索</el-button>
				<el-button size="mini" @click="reset">重置</el-button>
			</div>
		</div>
		<div v-loading="loading" class="v-content">
			<el-table border size="small" :data="lists" height="100%">
				<el-table-column prop="sort" label="排序" width="60"></el-table-column>
				<el-table-column prop="name" label="作品名称" ></el-table-column>
				<el-table-column prop="categoryName" label="所属分类" width="130">
          <template slot-scope="scope">
            {{scope.row.categoryName.map(item=>item.name).toString()}}
          </template>
        </el-table-column>
				<el-table-column prop="name" label="作品类型" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.type == 1 ">普通作品</span>
						<span v-if="scope.row.type == 2 ">外链作品</span>
						<span v-if="scope.row.type == 3 ">复拍作品</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="转码/总场" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.type != 2">{{ scope.row.count }}/{{ scope.row.total }}</span> <span v-if="scope.row.type == 2">-/-</span>
					</template>
				</el-table-column>
        <el-table-column label="启用状态" width="80">
          <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isShow"
            :active-value="1"
            :inactive-value="2"
          @change="setIsShow(scope.row)">
          </el-switch>
          </template>
        </el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
				<el-table-column label="操作" width="320" align="right" fixed="right">
					<template slot-scope="scope">
						<el-button size="min" class="v-ml-5" type="primary" :disabled="scope.row.count != scope.row.total && scope.row.type != 2" @click="toPreview(scope.row)">
							{{ scope.row.status == 1 ? "转码中" : "预览" }}
						</el-button>
						<el-button size="min" class="v-ml-5" type="warning" :disabled="scope.row.count == 0" @click="toConfig(scope.row)">配置</el-button>
						<el-button size="min" class="v-ml-5" type="success" :disabled="scope.row.type != 3" @click="row=scope.row;isShowVrRepeat = true">复拍</el-button>
						<el-button size="min" class="v-ml-5" icon="el-icon-paperclip" :disabled="scope.row.type == 2" @click="showPath(scope.row)"></el-button>
						<el-tooltip effect="dark" content="添加场景" placement="top">
							<el-button size="min" class="v-ml-5" icon="el-icon-plus" :disabled="scope.row.type === 2" @click="addScene(scope.row)"></el-button>
						</el-tooltip>
						<el-button size="min" class="v-ml-5" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
						<el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
							<el-button slot="reference" size="min" class="v-ml-5" icon="el-icon-delete" :loading="scope.row.deleteLoading"></el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="v-footer">
			<el-pagination layout="total,sizes,prev, pager, next" :current-page.sync="page" :total="total" @size-change=" page_size => {getList(page, page_size);}" @current-change="page => {getList(page);}"></el-pagination>
		</div>

		<addEdit v-if="isShowAddEdit" :show.sync="isShowAddEdit" :row="row" @success="getList($event)" />
		<addScene v-if="isShowAddScene" :works-id="row.id" :row="row" :show.sync="isShowAddScene" @success="getList($event)" />
		<vr-repeat v-if="isShowVrRepeat" :show.sync="isShowVrRepeat" :row="row" />
		<wx-path v-if="isShowPath" :show.sync="isShowPath" :row="row" />

	</div>
</template>

<script>
	import addEdit from "./components/add-edit";
	import addScene from './components/add-scene';
	import vrRepeat from './components/vr-repeat';
	import wxPath from './components/wx-path';

	export default {
		components: {addEdit, addScene, vrRepeat,wxPath},

		data() {
			return {
				page: 1,
				page_size: 10,
				total: 0,
				lists: [],
				isShowAddEdit: false,
				isShowAddScene: false,
				row: null,
				loading: false,
				keyword: "",
				userInfo: this.$store.state.user.userInfo,
				isShowVrRepeat: false,
				isShowPath:false
			};
		},

		created() {
			this.getList();
		},

		methods: {
			//全景列表
			async getList(page, page_size) {
				this.loading = true;
				this.page = page ? page : this.page;
				this.page_size = page_size ? page_size : this.page_size;
				try {
					let res = await this.api.works.lists({
						page: this.page,
						pageSize: this.page_size,
						keyword: this.keyword,
					});
					this.lists = res.data.data;
					this.total = res.data.total;
				} catch (e) {
					console.error(e);
				}
				this.loading = false;
			},

			reset() {
				this.keyword = "";
				this.status = "";
				this.getList(1);
			},


			add() {
				this.row = null;
				this.isShowAddEdit = true;
			},

			edit(row) {
				this.row = row;
				this.isShowAddEdit = true;
			},

			addScene(row) {
				this.row = row;
				this.isShowAddScene = true;
			},

			showPath(row){
				this.row = row;
				this.isShowPath = true;
			},

			//删除
			async doDelete(row) {
				this.$set(row, "deleteLoading", true);
				try {
					await this.api.works.delete({id: row.id});
					this.$message.success("删除成功");
					this.getList();
				} catch (e) {
					console.error(e);
				}
				this.$set(row, "deleteLoading", false);
			},

			async setIsShow(row) {
				try {
					await this.api.works.setIsShow({id: row.id,isShow:row.isShow});
					this.$message.success("更新成功");
				} catch (e) {
					console.error(e);
				}
			},

			//配置作品
			async toConfig(row) {
				let routeUrl = this.$router.resolve({
					path: "/tour",
					query: {id: row.id, name: row.name, type: row.type}
				});
				window.open(routeUrl.href, "_blank");
			},

			//预览作品
			async toPreview(row) {
				if (row.type == 2) {
					window.open(row.info.url, "_blank");
					return
				}
				let routeUrl = this.$router.resolve({
					path: "/preview",
					query: {id: row.id, subjectId: this.userInfo.subjectInfo.id}
				});
				window.open(routeUrl.href, "_blank");
			},

		}
	};
</script>

<style scoped>
	.v-header {
		display: flex;
		justify-content: space-between;
	}

	.cover-preview {
		display: block;
		height: 40px;
		margin: 0 auto;
	}

	.category-name {
		color: #3582d1;
	}

	.link {
		color: #3582d1;
		cursor: pointer;
	}

	.recommend-box ::v-deep .el-loading-spinner {
		margin-top: -10px;
	}

</style>
